export const ROUTES = {
	DEFAULT: '*',
	LOGIN: '/login',
	OTP: '/otp',
	INITIAL_OFFICE_SELECTION: '/initialOfficeSelection',
	PROFILE_COMPLETION: '/profileCompletion',
};
